window.OKJS = window.OKJS || {};
(function (OKJS) {
	OKJS.Press = {
		init: function () {

			if (!Modernizr.touchevents) {

				var copyTextArea = document.querySelector('.js-copy-source');
				if (copyTextArea) {
					OKJS.Press.setupCopyButton(copyTextArea);
				}

				var stickyCopyButton = document.querySelector('.js-sticky-copy-button');
				if (stickyCopyButton && window.innerWidth > 480) {
					OKJS.Press.setupStickyCopyButton(stickyCopyButton);
				}
			}
		},

		setupCopyButton: function (copyTextArea) {
			var copyTextBtn = document.querySelector('.js-copy-btn');

			copyTextBtn.addEventListener('click', function (event) {
				var thisBtn = event.currentTarget;

				thisBtn.querySelector('.tooltip__content').classList.remove("active");

				OKJS.Press.selectText(copyTextArea);

				try {
					var successful = document.execCommand('copy');
					if (successful) {
						thisBtn.querySelector('.tooltip__content').classList.add("active");
						setTimeout(function (thisBtn) {
							document.querySelector('.js-copy-btn .tooltip__content').classList.remove("active");
						}, 5000);
					} 
				} catch (err) {
					console.log('Fejl');
				}

				OKJS.Press.clearSelection();

			});
			
		},

		selectText: function(element) {
			var doc = document,
				range,
				selection;

			if (doc.body.createTextRange) {
				range = document.body.createTextRange();
				range.moveToElementText(element);
				range.select();
			} else if (window.getSelection) {
				selection = window.getSelection();
				range = document.createRange();
				range.selectNodeContents(element);
				selection.removeAllRanges();
				selection.addRange(range);
			}
		},

		clearSelection: function()	{
			if (window.getSelection) {
				window.getSelection().removeAllRanges();
			} else if (document.selection) {
				document.selection.empty();
			}
		},

		setupStickyCopyButton: function (stickyCopyButton) {
			var throttledStickyCopyButtonUpdate = OKJS.Global.throttle(function () { OKJS.Press.stickyCopyButtonUpdate(); }, 100, { trailing: false }),
				throttledStickyCopyButtonUpdatePlacement = OKJS.Global.throttle(function () { OKJS.Press.stickyCopyButtonUpdatePlacement(stickyCopyButton); }, 100, { trailing: false });

			window.addEventListener('scroll', function () { requestAnimationFrame(throttledStickyCopyButtonUpdate); }, Modernizr.passiveeventlisteners ? { passive: true } : false);
			window.addEventListener('resize', function () { requestAnimationFrame(throttledStickyCopyButtonUpdatePlacement); }, Modernizr.passiveeventlisteners ? { passive: true } : false);

			stickyCopyButton.dataset.left = stickyCopyButton.getBoundingClientRect().left + window.pageXOffset;
			stickyCopyButton.dataset.top = stickyCopyButton.getBoundingClientRect().top + window.pageYOffset;

			OKJS.Press.stickyCopyButtonUpdate();
		},
		stickyCopyButtonUpdatePlacement: function (stickyCopyButton) {

			stickyCopyButton.dataset.left = document.querySelector(".press__btns").getBoundingClientRect().right + 20;

			if (stickyCopyButton.parentNode.classList.contains("fixed")) {
				stickyCopyButton.setAttribute("style", "position: fixed; left:" + stickyCopyButton.dataset.left + "px; top: 20px;");
			}
		},
		stickyCopyButtonUpdate: function () {
			var pressCon = document.querySelector('.press article'),
				stickyCopyButton = document.querySelector('.js-sticky-copy-button'),
				verticalLimit = pressCon.getBoundingClientRect().bottom - (stickyCopyButton.offsetHeight + 80),
				scrollPosition = window.pageYOffset;

			if (scrollPosition > stickyCopyButton.dataset.top) {
				stickyCopyButton.parentElement.classList.add('fixed');
				if (verticalLimit > 0) {
					stickyCopyButton.setAttribute("style", "position: fixed; left:" + stickyCopyButton.dataset.left + "px; top: 20px;");
				} else {
					var styles = getComputedStyle(stickyCopyButton.parentNode);
					
					stickyCopyButton.setAttribute("style", "position: absolute; right: " + styles.right + "; bottom: 0px;");
				}
			} else {
				stickyCopyButton.parentElement.classList.remove('fixed');
				stickyCopyButton.setAttribute("style", "");
			}
		}

	};
}(window.OKJS));
